<template>
  <figure class="alert">
    <img
      src="../../../assets/images/alert.png"
      alt="alert icon"
      width="20px"
      height="17px"
    />
    <figcaption class="alert-text" v-if="alertText === 'not-found'">
      {{ alertJsonText.notFound[lang] }}
    </figcaption>
    <figcaption class="alert-text" v-if="alertText === 'cache-error'">
      {{ alertJsonText.cacheError[lang] }}
    </figcaption>
    <figcaption class="alert-text" v-if="alertText === 'invalid-token'">
      {{ alertJsonText.invalidToken[lang] }}
    </figcaption>
  </figure>
</template>

<script>
import Alert from "../../../assets/constants/confirmation/alert/alert";
export default {
  props: {
    lang: {
      type: String,
    },
    alertText: {
      type: String,
    },
  },
  computed: {
    alertJsonText: function () {
      return Alert;
    },
  },
  name: "Alert",
};
</script>

<style scoped>
.alert {
  min-width: 100vw;
  padding: 15px;
  border: solid 1px var(--redFoundationColor);
  text-align: center;
  color: var(--redFoundationColor);
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: var(--defaultWhiteColor);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  .alert-text {
    margin: 10px 0 0 0;
    line-height: 1.3;
    font-size: 14px;
    text-align: left;
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/Alert.vue